module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00031.f06138a.png";